import { EndpointsOptionsMap } from '../system';
import * as commonApi from './common';

export type CommonApiEndpointTypes = EndpointsOptionsMap<typeof commonApi>;
export { commonApi };
